import {WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;

export default {
  icon: <span className='icon-coms-cowork'/>,
  iconClassName: 'icon-coms-cowork',
  iconBgColor: '#A0B0BA',
  // themeMenu: [
  //   {key: '0', label: getLabel(83228, '全部主题')}, 
  //   {key: '1', label: getLabel(18874, '直接参与')}, 
  //   {key: '3', label: getLabel(83232, '我负责的')},
  //   {key: '4', label: getLabel(83233, '我创建的')}, 
  //   {key: '5', label: getLabel(83234, '待审批的')}, 
  //   {key: '2', label: getLabel(17692, '其他关注的')},
  // ],
  themeMenu: ()=> {
    return[
    {key: '0', label: getLabel(83228, '全部主题')},
    {key: '6', label: getLabel(382246, '仅参与的')},
    {key: '3', label: getLabel(382247, '仅负责的')},
    {key: '1', label: getLabel(382248, '负责或参与的')}, 
    {key: '4', label: getLabel(83233, '我创建的')}, 
    {key: '5', label: getLabel(83234, '待审批的')}, 
    {key: '2', label: getLabel(17692, '其他关注的')},  
  ]
},
  sortMenu : ()=> {
   return [
    {key: 'unread', label: getLabel(83229, '未读排序')}, {key: 'important', label: getLabel(382668, '标星排序')},
    {key: 'replyNum', label: getLabel(83236, '回复排序')}, {key: 'readNum', label: getLabel(83237, '查看排序')},
  ];
  },
};


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cowork/util/CoworkConstant.js